var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#D04D52","fillRule":"evenodd","d":"M10 2c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 11c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm0-8c-.513 0-.936.386-.993.883L9 6v4c0 .552.448 1 1 1 .513 0 .936-.386.993-.883L11 10V6c0-.552-.448-1-1-1z"}));
}

Alert.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Alert;

Alert.default = Alert;
